type SocialIconProps = {
  onClick?: () => void;
};

export const MastodonIcon = ({ onClick = () => {} }: SocialIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="41"
    height="40"
    viewBox="0 0 41 40"
    fill="none"
    className="cursor-pointer"
    onClick={onClick}
  >
    <g clipPath="url(#clip0_1662_7079)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.5 0C31.5378 0 40.5 8.95023 40.5 20C40.5 31.0378 31.5498 40 20.5 40C9.46219 40 0.5 31.0498 0.5 20C0.5 8.96219 9.45023 0 20.5 0Z"
        fill="url(#paint0_linear_1662_7079)"
      />
      <path
        d="M31.0085 13.7093C30.6822 11.2836 28.568 9.3718 26.0616 9.00141C25.6387 8.93883 24.0368 8.71094 20.3256 8.71094H20.298C16.5858 8.71094 15.7894 8.93883 15.3666 9.00141C12.9301 9.36156 10.705 11.0792 10.1651 13.5337C9.90554 14.7425 9.87773 16.0827 9.92601 17.312C9.99476 19.0749 10.0081 20.8346 10.1683 22.5904C10.2789 23.7567 10.472 24.9136 10.746 26.0527C11.2591 28.1561 13.3365 29.9066 15.3717 30.6209C17.5506 31.3656 19.8938 31.4893 22.1391 30.978C22.3855 30.9207 22.6296 30.8539 22.8708 30.7779C23.4168 30.6045 24.0562 30.4105 24.5264 30.0698C24.5328 30.065 24.5381 30.0589 24.5419 30.0518C24.5456 30.0447 24.5476 30.0368 24.5479 30.0288V28.3275C24.5478 28.3162 24.5438 28.3052 24.5367 28.2964C24.5295 28.2877 24.5196 28.2816 24.5085 28.2792C24.5012 28.2776 24.4936 28.2776 24.4863 28.2792C23.0478 28.6228 21.5737 28.7951 20.0948 28.7923C17.5494 28.7923 16.8649 27.5846 16.669 27.0819C16.5113 26.6473 16.4113 26.194 16.3712 25.7335C16.3708 25.7257 16.3722 25.718 16.3753 25.7109C16.3785 25.7038 16.3833 25.6975 16.3894 25.6927C16.3953 25.6877 16.4024 25.6843 16.4099 25.6827C16.4174 25.681 16.4253 25.6812 16.4327 25.6832C17.8473 26.0244 19.2974 26.1967 20.7526 26.1962C21.1025 26.1962 21.4515 26.1963 21.8014 26.187C23.2648 26.1459 24.8076 26.071 26.2473 25.7898C26.2833 25.7827 26.3193 25.7765 26.35 25.7673C28.6212 25.3311 30.7827 23.9623 31.0023 20.4961C31.0105 20.3595 31.0311 19.0666 31.0311 18.9252C31.0319 18.4439 31.186 15.5112 31.0085 13.7093ZM27.4102 16.4347V22.4612H25.0221V16.6122C25.0221 15.3809 24.5089 14.7528 23.4651 14.7528C22.3176 14.7528 21.7429 15.4958 21.7429 16.963V20.1647H19.3691V16.963C19.3691 15.4958 18.7934 14.7528 17.6459 14.7528C16.6084 14.7528 16.09 15.3809 16.09 16.6122V22.4612H13.7029V16.4347C13.7029 15.2034 14.0173 14.2251 14.646 13.4998C15.2947 12.7765 16.1455 12.4051 17.2015 12.4051C18.4238 12.4051 19.3475 12.8751 19.9633 13.8139L20.5576 14.8113L21.1528 13.8139C21.7686 12.8751 22.6923 12.4051 23.9125 12.4051C24.9676 12.4051 25.8184 12.7765 26.4691 13.4998C27.0973 14.2245 27.4109 15.2027 27.4102 16.4347Z"
        fill="white"
      />
      <circle cx="20.5" cy="20" r="19.375" stroke="#1B1D21" strokeWidth="1.25" />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_1662_7079"
        x1="20.1148"
        y1="0.000234375"
        x2="20.1148"
        y2="39.6459"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6364FF" />
        <stop offset="1" stopColor="#563ACC" />
      </linearGradient>
      <clipPath id="clip0_1662_7079">
        <rect width="40" height="40" fill="white" transform="translate(0.5)" />
      </clipPath>
    </defs>
  </svg>
);
